<template>
  <div class="wrap">
    <div class="query-banner">
      <div class="banner-center">
        <div class="banner-center-title">关于统信软件教育与考试中心</div>
      </div>
    </div>
    <div class="uos-title">统信软件教育与考试中心简介</div>
    <div class="college-main">
      <div class="college-img">
        <img src="../../../static/images/imgs/uos-desc.png" alt="" style="width:476px;height:356px;">
      </div>
      <div class="space-between"></div>
      <div class="college-content">
        <div class="college-font">
          <p>
            <span>
              {{collegeIntroP1}} 
              {{collegeIntroP2}} 
            </span>
          </p>
        </div>
      </div>
    </div>
    <div class="advantage-bg">
      <div class="uos-title">我们的优势</div>
      <div class="advantage-c">
        <div class="advantage-i" v-for="(item, index) in advantage" :key="index">
          <!-- <img src="../../assets/material_support.svg" style="height: 70px;width: 70px;" alt=""> -->
        
            <div class="advantage-i-c">
              <div class="advantage-i-c-t">{{item.advanTitle}}</div>
              <div class="advantage-i-c-i">{{item.advanDescription}}</div>
            </div>
        </div>
      </div>
    </div>
  </div>
      
      
</template>
<script>
import {collegeIntroP1,collegeIntroP2,advantage} from "../../common/introduce"
export default {
  name: '',
  props: {},
  data() {
    return {
      collegeIntroP1,
      collegeIntroP2,
      advantage
    };
  },
  computed: {},
  watch: {},
  methods: {},
  created() {
},
  mounted() {
},
  beforeUnmount() {
},
  components: {},
  filters: {}
};
</script>
<style lang='scss' scoped>
.wrap{
  // background: #fff;
}
.wrap .query-banner{
  position: relative;
  height: 400px;
  background-image: url("../../assets/txcollege.png");
  text-align: center;
  // line-height: 400px;
  font-size: 48px;
  color: #fff;
  // p{
  //   font-size: 48px;
  //   font-weight: 400;
  //   color: #fff;
   
  // }
  // span{
  //   color: #fff;
  // }
}
.banner-center{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  text-align: center;
  line-height: 90px;
}
.ant-btn{
  width: 200px;
  height: 56px;
  // border:2px solid #fff;
  border-radius: 8px;
  background: 0 0;
  color: #fff;
  font-size: 20px;
  img{
    margin-right: 6px;
  }
}
.uos-title{
  text-align: center;
    font-size: 36px;
    font-weight: 400;
    color: #333;
    line-height: 54px;
    padding: 80px 0 60px;
}
.college-main{
  display: flex;
    -webkit-box-pack: center;
    justify-content: center;
    margin-bottom: 90px;
}
.college-img{
    width: 476px;
    height: 356px;
}
.space-between{
    width: 38px;
}
.college-font{
  width: 687px;
    height: 356px;
    font-size: 18px;
    font-family: SourceHanSansSC-Regular,SourceHanSansSC;
    font-weight: 400;
    color: #666;
    line-height: 27px;
}
.college-font p{
    text-align: justify;
    text-indent: 2em;
}
.advantage-bg {
    background: #f5f5f5;
}
.advantage-c {
    display: -webkit-box;
    display: flex;
    -webkit-box-pack: justify;
    justify-content: space-between;
    width: 1200px;
    margin: auto;
    flex-wrap: wrap;
}

.advantage-c .advantage-i {
    width: 380px;
    height: 240px;
    background: #fff;
    box-shadow: 0 4px 10px 2px rgba(0,0,0,.05);
    border-radius: 8px;
    text-align: center;
    padding-top: 20px;
    padding-bottom: 25px;
    margin-bottom: 80px;
    img, input, select {
    vertical-align: middle;
}
}
.advantage-c .advantage-i .advantage-i-c {
    height: 166px;
    position: relative;
}

.advantage-c .advantage-i .advantage-i-c .advantage-i-c-t {
    font-size: 20px;
    font-weight: 400;
    color: #333;
    line-height: 30px;
    margin-top: 30px;
}
.advantage-c .advantage-i .advantage-i-c .advantage-i-c-i {
    width: 291px;
    font-size: 14px;
    font-weight: 400;
    color: #999;
    line-height: 21px;
    margin: 20px auto;
}
</style>